import * as Sentry from '../../lib/client/sentry/sentry';

import { postRequestOptions } from './form-utils';

export const CONTENTREPORTINGAPI_URL = process.env.REACT_APP_CONTENTREPORTING_API_URL || '';

export const fetchResolveUris = async uris => {
  const options = postRequestOptions({
    uris,
  });

  try {
    const response = await fetch(`${CONTENTREPORTINGAPI_URL}/v1/entity-type`, options);
    if (response.ok) {
      const { resolvedEntityType } = await response.json();

      return { resolvedUris: resolvedEntityType, requestError: false };
    }
    const { message } = await response.json();
    Sentry.captureException(`Called "/v1/entity-type", got status: ${response.status}. Error: ${message}`);
  } catch (e) {
    Sentry.captureException(e);
  }

  return { resolvedUris: null, requestError: true };
};
